import { CommonModule } from '@angular/common';
import {Component, HostListener} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { InstallationService } from '@shared/services/installation.service';
import { LanguagesService } from '@shared/services/languages.services';
import {SharedWorkerService} from "@shared/services/shared-worker.service";
import {TranslationService} from "@shared/services/translation.service";
import {filter} from 'rxjs';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    imports: [
        CommonModule,
        RouterOutlet,
    ]
})
export class AppComponent {
    @HostListener('window:beforeunload', [])
    unloadHandler() {
        // Disconnect tab from the shared worker
        // [NOTE]: Normally this happens inside the service itself,
        // but for some reason it is not triggering for the login project
        this.sharedWorkerService.disconnect();
    }

    constructor(
        private _installationService: InstallationService,
        private sharedWorkerService: SharedWorkerService,
        private _translationService: TranslationService,
        private _languagesService: LanguagesService,
    ) {
        this._getInstallation();

        this._languagesService.languageChanged$
            .pipe(takeUntilDestroyed(), filter(lang => !!lang))
            .subscribe(this._translationService.changeLang.bind(this._translationService));

        // Stop the current tab from listening to the previously selected lab
        this.sharedWorkerService.postMessage("socket", "disconnect");

        this._translationService.initLanguage();
    }

    private _getInstallation(): void {
        this._installationService.createInstallationIfNotExists();
    }
}
